import { AppColors } from "@/styles/colors";
import { Flex, Text } from "@chakra-ui/react";
import { SearchX } from "lucide-react";

export const NotFoundPage = () => {
  return (
    <Flex
      flexDir="column"
      justifyContent="center"
      alignItems="center"
      height="100vh"
    >
      <SearchX
        data-testid="lucide-search"
        size={172}
        color={AppColors.GRAY_TEXT}
      />
      <Text fontWeight={600} fontSize="18px">
        Página no encontrada
      </Text>
    </Flex>
  );
};
